import { MultiSelect } from "@mantine/core";
import { useState, useEffect } from "react";
import _ from "lodash";
import { useServerApi } from "../hooks/userServerApi";
import {
  mergeBankTransactionTagOptions,
  normalizeBankTransactionTags,
} from "../helpers/bankTransactionTags";

const tagsFromDistinct = (distinct) =>
  (Array.isArray(distinct) ? distinct : [])
    .map((item) =>
      typeof item === "string" ? item : item?.value ?? item?.label
    )
    .filter(Boolean);

const BankTransactionTagsInput = ({
  form,
  name,
  label,
  placeholder,
  ...props
}) => {
  const tags = _.get(form.values, name) ?? [];
  const [api] = useServerApi();
  const [usedTags, setUsedTags] = useState([]);
  const [createdTags, setCreatedTags] = useState([]);

  useEffect(() => {
    let cancelled = false;
    Promise.resolve(
      api.getDistinctValues?.({
        apiEntity: "bankTransaction",
        field: "tags",
      })
    )
      .then((distinct) => {
        const next = tagsFromDistinct(distinct);
        if (!cancelled && next.length > 0) setUsedTags(next);
      })
      .catch(() => {});
    return () => {
      cancelled = true;
    };
  }, [api]);

  const data = mergeBankTransactionTagOptions(usedTags, createdTags, tags);

  const handleChange = (value) => {
    form.setFieldValue(name, normalizeBankTransactionTags(value));
    if (props.onChange) props.onChange(value);
  };

  return (
    <MultiSelect
      {...props}
      label={label}
      placeholder={placeholder}
      data={data}
      searchable
      creatable
      nothingFound="Not Found"
      value={tags}
      onChange={handleChange}
      getCreateLabel={(query) => `+ Create ${query}`}
      onCreate={(query) => {
        const trimmed = query.trim();
        if (!trimmed) return null;
        setCreatedTags((current) =>
          current.includes(trimmed) ? current : [...current, trimmed]
        );
        return trimmed;
      }}
    />
  );
};

export default BankTransactionTagsInput;
